// Frosted top bar: the Grit mark on the left, the signed-in person's avatar on the
// right (opens the account menu, wired via document-level delegation in main.js).
// While viewing the other athlete, a pill says so and taps back to your own training.

import { logoHeader } from './logo.js';
import { activeUser, label, viewing, isViewingSelf, userColor } from '../lib/auth.js';
import { pendingCount } from '../lib/db.js';

// "N waiting to send": saves made without signal, held on the phone (lib/db.js outbox).
export function pendingPill(n = pendingCount()) {
  return n ? `<span id="grit-pending" role="status" class="grit-chip bg-[#FBF3E0] text-[#7A570F]">${n} waiting to send</span>` : '<span id="grit-pending" class="hidden"></span>';
}

export function renderHeader({ rightSlot = null } = {}) {
  const me = activeUser();
  const them = viewing();
  const viewingPill = isViewingSelf() ? '' : `
    <button data-action="back-to-self" class="grit-pill !min-h-[36px]" style="background:${userColor(them).soft};color:${userColor(them).deep}" aria-label="Back to my training">
      Viewing ${label(them)}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>`;
  const right = rightSlot ?? `
    <div class="flex items-center gap-2">
      ${pendingPill()}
      ${viewingPill}
      <button data-action="account-menu" aria-label="Account: ${label(me)}"
        class="w-11 h-11 -mr-1.5 flex items-center justify-center active:scale-95 transition-transform">
        <span class="w-9 h-9 rounded-full flex items-center justify-center text-white text-[17px] font-semibold" style="background:${userColor(me).deep}">${label(me).slice(0, 1)}</span>
      </button>
    </div>`;
  return `
    <header class="grit-header">
      <div class="max-w-md mx-auto px-5 h-[52px] flex items-center justify-between">
        ${logoHeader({ onDark: false })}
        ${right}
      </div>
    </header>`;
}
